export default "__VITE_ASSET__BkXL3XvV__"